var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotateRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8058_2966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.06775 4V10M1.06775 10H7.47453M1.06775 10L6.02233 5.64C7.49686 4.26142 9.40986 3.36897 11.4731 3.09712C13.5363 2.82526 15.638 3.18873 17.4615 4.13276C19.2849 5.07679 20.7314 6.55024 21.5829 8.3311C22.4345 10.112 22.6449 12.1037 22.1826 14.0064C21.7203 15.909 20.6102 17.6193 19.0197 18.8798C17.4291 20.1402 15.4443 20.8824 13.3642 20.9945C11.2841 21.1066 9.22142 20.5826 7.48698 19.5014C5.75253 18.4202 4.44027 16.8404 3.74792 15",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8058_2966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6271,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRow);
export default __webpack_public_path__ + "static/media/rotate-row.575865b6714ac6bbd749f6fd2343aaa0.svg";
export { ForwardRef as ReactComponent };